import type { AppConfigInfo, SessionUser } from "@/api";
import { roleAtLeast } from "@/lib/roles";

/** UI availability only; SessionGuard and the tenant feature service authorize every request. */
export function testMailContextKey({ user, config, tenantContext }: {
  user: SessionUser | null;
  config: AppConfigInfo | null;
  tenantContext: string | null;
}): string | null {
  if (!user || !roleAtLeast(user.role, "admin") || user.tenantStatus !== "active"
      || config?.features?.test_injection !== true) return null;
  // An owner must name the injection business explicitly. Never borrow the Lab's tenant, or
  // pair a pending switch with the previous session's tenant/config.
  const tenantId = user.role === "owner" ? tenantContext : user.tenantId;
  if (!tenantId || tenantId !== user.tenantId || (user.role !== "owner" && tenantContext)) return null;
  return JSON.stringify([user.id, user.role, tenantId]);
}
